module.exports = __webpack_public_path__ + "static/media/taylor-swift-icon.758532e5.jpg";